import { useCallback } from "react";
import useExchangeContract from "../useExchangeContract";

export default function useCancelOrderNonce() {
  const exchangeContract = useExchangeContract();

  return useCallback(
    async (orderNonce?: string) => {
      if (!orderNonce) {
        throw new Error("Order nonce does not exist");
      }

      const tx = await exchangeContract!.cancelNonce(orderNonce);
      await tx.wait();
    },
    [exchangeContract],
  );
}
